import React, { useContext, useEffect } from 'react'
import { ProgressIndicator } from '@jarvis/react-setup-and-onboarding-addons'
import { ConfigContext } from 'src/store/ConfigContext'
import useSimpleUiAnalytics from 'src/hooks/useSimpleUiAnalytics'
import useContentStack from 'src/hooks/useContentStack'
import { ContentStackContentTypes } from 'src/config/constants'
import { VeneerIcon } from 'src/components/VeneerIcon'

import { ANALYTICS } from '../config/constants'

import classes from './HPAllInMain.module.scss'

const { SCREENS } = ANALYTICS

const parseContentStackData = (response) => {
  return {
    header: response.header,
    subhead: response.subhead,
    logo: response.logo?.logo,
    body: response.body
  }
}

/**
 * HPAllInMain renders the CMS content while the PortalEntry
 * handles the API flow in the background.
 * CMS fields: header, subhead, logo, body
 */
const HPAllInMain = () => {
  const { direction } = useContext(ConfigContext)
  const { pageData } = useContentStack(
    ContentStackContentTypes.hp_allin_activation,
    parseContentStackData
  )
  const { fireScreenDisplayed } = useSimpleUiAnalytics(
    SCREENS.START,
    true,
    ANALYTICS
  )

  useEffect(() => {
    if (pageData) {
      fireScreenDisplayed()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageData])

  if (!pageData) {
    return null
  }

  const { header, subhead, logo, body } = pageData

  return (
    <div
      className={classes['hpallinMainWrapper']}
      dir={direction}
    >
      <div className={classes['hpallinMain']}>
        <div className={classes['logo']}>
          <VeneerIcon
            icon={logo}
            size={72}
          />
        </div>
        <h1
          className={classes['header']}
          dangerouslySetInnerHTML={{ __html: header }}
        />
        <p
          className={classes['subhead']}
          dangerouslySetInnerHTML={{ __html: subhead }}
        />
        <div className={classes['progressBar']}>
          <ProgressIndicator
            data-testid="hpallin-progress-bar"
            appearance="linear"
            behavior="indeterminate"
            className={classes['progressIndicator']}
          />
        </div>
        <p
          className={classes['body']}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </div>
  )
}

export default HPAllInMain
